import React from 'react';
import { formatCompactMoney } from '../../utils/todayStats';

export default function PipelineSnapshot({ stages, isMobile }) {
  return (
    <div className="today-panel">
      <div className="today-panel-header">
        <span className="today-panel-title">Pipeline</span>
      </div>
      <div
        className="today-pipeline-grid"
        style={isMobile ? { overflowX: 'auto', gridTemplateColumns: `repeat(${stages.length}, minmax(140px, 1fr))` } : undefined}
      >
        {stages.map((stage) => {
          const valueLabel = formatCompactMoney(stage.value);
          return (
            <div
              key={stage.id}
              className={`today-pipeline-cell${stage.tinted ? ' tinted' : ''}`}
            >
              <div className={`today-pipeline-label${stage.tinted ? ' accent' : ''}`}>{stage.label}</div>
              <div className="today-pipeline-count-row">
                <span className="today-pipeline-count">{stage.count}</span>
                {valueLabel && (
                  <span className={`today-pipeline-value${stage.tinted ? ' accent' : ''}`}>{valueLabel}</span>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
